import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import Tabs from '../../../../../../../../../components/Tabs'
import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import Authorities from './components/Authorities'
import CourseOfAction from './components/CourseOfAction'
import EndUsersSK from './components/EndUsersSK'
import Managers from './components/Managers'
import Representatives from './components/Representatives'
import BeneficialOwners from './components/BeneficialOwners'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@injectIntl
export default class Persons extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    render() {
        const { id, data, module, block, level, intl } = this.props

        return (
            <div className={'block-persons'}>
                <Tabs
                    level={level}
                    id={`persons-tabs-${id}`}
                    key={`persons-tabs-${id}`}
                    tabs={[
                        {
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.authorities` }),
                            counter: {
                                left: {
                                    count: _.get(data, '[0].statutoryBodiesActive', 0),
                                },
                                right: {
                                    count: _.get(data, '[0].statutoryBodiesTotal', 0),
                                },
                            },
                            locked:
                                _.isNil(data?.[0]?.statutoryBodiesActive) && _.isNil(data?.[0]?.statutoryBodiesTotal),
                            content: (
                                <Authorities
                                    module={module}
                                    block={block}
                                    id={id}
                                    level={level}
                                    locked={
                                        _.isNil(data?.[0]?.statutoryBodiesActive) &&
                                        _.isNil(data?.[0]?.statutoryBodiesTotal)
                                    }
                                    data={_.get(data, '[1].statutoryBodies', [])}
                                />
                            ),
                        },
                        {
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.beneficialOwners` }),
                            counter: {
                                left: {
                                    count: _.get(data, '[0].beneficialOwnersActive', 0),
                                },
                            },
                            locked: _.isNil(data?.[0]?.beneficialOwnersActive),
                            content: (
                                <BeneficialOwners
                                    module={module}
                                    blockKey={block}
                                    id={id}
                                    level={level}
                                    locked={_.isNil(data?.[0]?.beneficialOwnersActive)}
                                    data={_.get(data, '[4].beneficialOwners', [])}
                                />
                            ),
                        },
                        {
                            counter: {
                                left: {
                                    count: _.get(data, '[0].endUserBenefitsActive', 0),
                                },
                                right: {
                                    count: _.get(data, '[0].endUserBenefitsTotal', 0),
                                },
                            },
                            locked:
                                _.isNil(data?.[0]?.endUserBenefitsActive) && _.isNil(data?.[0]?.endUserBenefitsTotal),
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.endUsers` }),
                            content: (
                                <EndUsersSK
                                    module={module}
                                    block={block}
                                    id={id}
                                    level={level}
                                    locked={
                                        _.isNil(data?.[0]?.endUserBenefitsActive) &&
                                        _.isNil(data?.[0]?.endUserBenefitsTotal)
                                    }
                                    veritifcationDocuments={data?.[1]?.documents || []}
                                    publicOfficialsData={_.get(data, '[1].publicOfficials', [])}
                                />
                            ),
                        },
                        {
                            counter: {
                                left: {
                                    count: _.get(data, '[0].employeeActive', 0),
                                },
                                right: {
                                    count: _.get(data, '[0].employeeTotal', 0),
                                },
                            },
                            locked: _.isNil(data?.[0]?.employeeActive) && _.isNil(data?.[0]?.employeeTotal),
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.managers` }),
                            content: (
                                <Managers
                                    module={module}
                                    block={block}
                                    id={id}
                                    level={level}
                                    locked={_.isNil(data?.[0]?.employeeActive) && _.isNil(data?.[0]?.employeeTotal)}
                                    data={_.get(data, '[1].managers', [])}
                                />
                            ),
                        },
                        {
                            counter: {
                                left: {
                                    count: _.get(data, '[0].representativeActive', 0),
                                },
                                right: {
                                    count: _.get(data, '[0].representativeTotal', 0),
                                },
                            },
                            locked: _.isNil(data?.[0]?.representativeActive) && _.isNil(data?.[0]?.representativeTotal),
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.representatives` }),
                            subtitle: intl.formatMessage({ id: `${LOCALE_PREFIX}.activeHistoric` }),
                            content: (
                                <Representatives
                                    module={module}
                                    block={block}
                                    id={id}
                                    level={level}
                                    locked={
                                        _.isNil(data?.[0]?.representativeActive) &&
                                        _.isNil(data?.[0]?.representativeTotal)
                                    }
                                />
                            ),
                        },
                        {
                            counter: {
                                left: {
                                    count: _.get(data, '[0].actionActive', 0),
                                },
                                right: {
                                    count: _.get(data, '[0].actionTotal', 0),
                                },
                            },
                            locked: _.isNil(data?.[0]?.actionActive) && _.isNil(data?.[0]?.actionTotal),
                            title: intl.formatMessage({ id: `${LOCALE_PREFIX}.courseOfAction` }),
                            content: (
                                <CourseOfAction
                                    module={module}
                                    block={block}
                                    id={id}
                                    level={level}
                                    locked={_.isNil(data?.[0]?.actionActive) && _.isNil(data?.[0]?.actionTotal)}
                                    data={_.get(data, '[1].wayOfNegotiation', [])}
                                />
                            ),
                        },
                    ]}
                />
            </div>
        )
    }
}
